// FIRST import: defers ResizeObserver delivery by a frame so the benign
// "loop completed with undelivered notifications" error never fires (must run
// before Highcharts/flowbite capture the global).
import './utils/resizeObserverPatch';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './pages/App';
import { BrowserRouter} from "react-router-dom";
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './config/queryClient';

// Highcharts global options are applied in components/charts/highcharts.js,
// inside the chart chunks, so the library is not part of the initial download.

// Benign per the ResizeObserver spec: "loop completed with undelivered
// notifications" (and the older "loop limit exceeded") mean layout kept
// changing while observations were being delivered — the leftovers are
// delivered next frame, nothing is lost. Our tabs keep panels mounted and
// flip display:none↔block (Tabs.js), so every Highcharts reflow observer in
// the incoming panel fires at once and trips this. Browsers report it as a
// window error and CRA's dev overlay escalates it to the red screen; filter
// exactly these two messages and nothing else.
const RESIZE_OBSERVER_NOISE = [
  'ResizeObserver loop completed with undelivered notifications',
  'ResizeObserver loop limit exceeded',
];
window.addEventListener('error', (event) => {
  if (RESIZE_OBSERVER_NOISE.some((msg) => event.message?.includes(msg))) {
    event.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
